import React, { Component } from 'react';
import '../styles/loadingtext.css';

var checkmarkIdPrefix = "loadingCheckSVG-";
var checkmarkCircleIdPrefix = "loadingCheckCircleSVG-";
var verticalSpacing = 50;

export default class LoadingText extends Component{
  componentDidMount(){
    this.runAnimation()
  }

    shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }

    createSVG(tag, properties, opt_children) {
      var newElement = document.createElementNS("http://www.w3.org/2000/svg", tag);
      for(var prop in properties) {
        newElement.setAttribute(prop, properties[prop]);
      }
      if (opt_children) {
        opt_children.forEach(function(child) {
          newElement.appendChild(child);
        })
      }
      return newElement;
    }

    createPhraseSvg(phrase, yOffset) {

      var text = this.createSVG("text", {
        fill: "#f48500",
        x: 50,
        y: yOffset,
        "font-size": 18,
      });
      text.appendChild(document.createTextNode(phrase + "..."));
      return text;
    }

    createCheckSvg(yOffset, index) {
      var check = this.createSVG("polygon", {
        points: "21.661,7.643 13.396,19.328 9.429,15.361 7.075,17.714 13.745,24.384 24.345,9.708 ",
        fill: "rgba(255,255,255,1)",
        id: checkmarkIdPrefix + index
      });
      var circle_outline = this.createSVG("path", {
        d: "M16,0C7.163,0,0,7.163,0,16s7.163,16,16,16s16-7.163,16-16S24.837,0,16,0z M16,30C8.28,30,2,23.72,2,16C2,8.28,8.28,2,16,2 c7.72,0,14,6.28,14,14C30,23.72,23.72,30,16,30z",
        fill: "#f48500"
      })
      var circle = this.createSVG("circle", {
        id: checkmarkCircleIdPrefix + index,
        fill: "rgba(255,255,255,0)",
        cx: 16,
        cy: 16,
        r: 15
      })
      var group = this.createSVG("g", {
        transform: "translate(10 " + (yOffset - 20) + ") scale(.9)"
      }, [circle, check, circle_outline]);
      return group;
    }

    addPhrasesToDocument(phrases) {
      phrases.forEach(function(phrase, index) {
        var yOffset = 30 + verticalSpacing * index;
        document.getElementById("phrases").appendChild(this.createPhraseSvg(phrase, yOffset));
        document.getElementById("phrases").appendChild(this.createCheckSvg(yOffset, index));
      }.bind(this));
    }

    easeInOut(t) {
      var period = 200;
      return (Math.sin(t / period + 100) + 1) /2;
    }

    runAnimation(){

      var phrases = ["資料查詢中", "FB連線中", "資訊準備中", "圖表產生中"];
      this.addPhrasesToDocument(phrases);
      var start_time = new Date().getTime();
      var upward_moving_group = document.getElementById("phrases");
      upward_moving_group.currentY = 0;
      var checks = phrases.map(function(_, i) { 
        return {check: document.getElementById(checkmarkIdPrefix + i), circle: document.getElementById(checkmarkCircleIdPrefix + i)};
      });
      // function animateLoading() {
      //   var now = new Date().getTime();
      //   upward_moving_group.setAttribute("transform", "translate(0 " + upward_moving_group.currentY + ")");
      //   upward_moving_group.currentY -= 1.35 * this.easeInOut(now);
      //   checks.forEach(function(check, i) {
      //     var color_change_boundary = - i * verticalSpacing + verticalSpacing + 15;
      //     if (upward_moving_group.currentY < color_change_boundary) {
      //       var alpha = Math.max(Math.min(1 - (upward_moving_group.currentY - color_change_boundary + 15)/30, 1), 0);
      //       check.circle.setAttribute("fill", "rgba(255, 255, 255, " + alpha + ")");
      //       var check_color = [Math.round(255 * (1-alpha) + 120 * alpha), Math.round(255 * (1-alpha) + 154 * alpha)];
      //       check.check.setAttribute("fill", "rgba(255, " + check_color[0] + "," + check_color[1] + ", 1)");
      //     }
      //   })
      //   if (now - start_time < 30000 && upward_moving_group.currentY > -710) {
      //     requestAnimationFrame(animateLoading);
      //   }
      // }
      // animateLoading();
    }

  render () {

      return (
        <div id="page">
          <div id="phrase_box">
          <svg width="100%" height="100%">
            <defs>
  
              <mask id="mask" maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse">
                <linearGradient id="linearGradient" gradientUnits="objectBoundingBox" x2="0" y2="1">
                  <stop stopColor="white" stopOpacity="0" offset="0%"/>
                  <stop stopColor="white" stopOpacity="1" offset="30%"/>
                  <stop stopColor="white" stopOpacity="1" offset="70%"/>
                  <stop stopColor="white" stopOpacity="0" offset="100%"/>
                </linearGradient>
                <rect width="100%" height="100%" fill="url(#linearGradient)"/>
              </mask>
            </defs>
            <g width="100%" height="100%" style={{mask: 'url(#mask)'}}>
              <g id="phrases"></g>
            </g>
          </svg>
          </div>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/loadingText.js